import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cx } from '@/lib/cx';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  /** 文字数カウンタを表示（maxLength と併用） */
  showCount?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, rows = 4, showCount, ...rest },
  ref,
) {
  const el = (
    <textarea ref={ref} rows={rows} aria-invalid={invalid || undefined} className={cx('bs-input bs-textarea', className)} {...rest} />
  );
  if (!showCount || rest.maxLength == null) return el;
  const len = typeof rest.value === 'string' ? rest.value.length : null;
  return (
    <span className="bs-textarea-wrap">
      {el}
      {len != null && (
        <span className="bs-textarea-count">
          {len} / {rest.maxLength}
        </span>
      )}
    </span>
  );
});
